import { render, staticRenderFns } from "./Failed-Application.vue?vue&type=template&id=5b6ab660&"
import script from "./Failed-Application.vue?vue&type=script&lang=ts&"
export * from "./Failed-Application.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports